<template>
    <!-- contents -->
    <div>
        <!-- detail_Code Manage -->
        <div class="grid_wrap mt25">
            <div class="sub_tit">Basic Information</div>
        </div>
        <table class="create_table">
            <colgroup>
                <col width="14.5%" />
                <col width="*" />
                <col width="13.5%" />
                <col width="*" />
            </colgroup>
            <tbody>
                <tr>
                    <th>Contents Type<em class="txt_mandatory">*</em></th>
                    <td>
                        <select class="slt_white w100" v-model="distinctionType" :disabled="viewMode">
                            <option value="SB" selected>Service Bulletin</option>
	                        <option value="MX" >Service Bulletin(Mobile)</option>
                        </select>
                    </td>
                    <th>Product Category<em class="txt_mandatory">*</em></th>
                    <td v-if="distinctionType == 'SB'">
                        <select class="slt_white w100"
                                id="categoryStatus"
                                v-model="categoryStatus"
                                @change="changeCategory1($event)"
                               
                        >
                            <option value="" selected>ALL</option>
                            <option v-if="categoryComboList.length > 0"
                                    v-for="item in categoryComboList"
                                    :key="item.code"
                                    :value="item.code"
                            >{{item.codeName}}</option>
                        </select>
                    </td>
                    <td v-if="distinctionType == 'MX' ">
                    	 <select class="slt_white w100" v-model="categoryStatusMX" :disabled="true">
	                        <option value="D" selected>Mobile Phone</option>
                        </select>
                    </td>
                    
                </tr>
                <tr>
                    <th v-if="distinctionType == 'SB'">Guide Type<em class="txt_mandatory">*</em></th>
                    <td v-if="distinctionType == 'SB'">
                        <select class="slt_white w100" v-model="guideType">
                            <option value="" selected>Select Guide Type</option>
                            <option value="ALL">ALL (including five types below)</option>
                            <option value="P">Parts Used</option>
		                    <option value="S">S/W & Firmware</option>
		                    <option value="A">Alternative Parts</option>
		                    <option value="O">On Site Check Guide</option>
		                    <option value="R">Repair Information & Tips</option>
		                    <option value="M">Manufacturing BOM Change</option>
                        </select>
                    </td>
<!--                     <td v-if="distinctionType == 'MX'"> -->
<!--                         <select class="slt_white w100" v-model="guideTypeMX" :disabled="true"> -->
<!--                             <option value="ALL">ALL</option> -->
<!-- 		                    <option value="A">Alternative Parts</option> --> 
<!--                         </select> -->
<!--                     </td> -->
                    
                    <th>Role<em class="txt_mandatory">*</em></th>
                    <td>
                        <select class="slt_white w100" v-model="roleStatus">
                             <option value="" selected>{{$t('FIELD.FAST.DURATION.ALL')}}</option>
                             <option value="1">Approval</option>
                             <option value="2">Consent</option>
                             <option value="3">Post Approval</option>
                             <option value="4">Parallel Consent</option>
                             <option value="7">Parallel Approval</option>
                             <option value="9">Notification</option>
                        </select>
                    </td>
                </tr>
                <tr>
		            	<th>Sort<em class="txt_mandatory">*</em></th>
	                    <td>
	                        <input ref="SORTORD" type="text" class="text_input w100"  
	                        	v-model="SORTORD" :disabled="false"  
	                        	placeholder="Please set the approval order."
							  	maxlength="10"
							  	@input="handleNumberInput"
	                         />
	                    </td>
	                    
	                    
	                </tr>
	                <tr>
	                	<th>User Name/Email <em class="txt_mandatory">*</em></th>
	                    <td >
	                        <fieldset class="ui_fieldset">
	                             <label class="serach-wrap w100p">
	                                 <input
	                                     type="text"
	                                     class="text_input"
	                                     v-model="emailAddresses"
	                                     @keyup.enter.stop="emailAddressFind(emailAddresses)"
	                                 />
	                                 <a
	                                     href="javascript:"
	                                     class="in_btn_search"
	                                     @click="emailAddressFind(emailAddresses)"
	                                 >
	                                     <i class="ico_input_serach"></i>
	                                     <span class="sr_only"></span>
	                                 </a>
	                             </label>
	                         </fieldset>
	                    </td>
	                    <th>Name </th>
	                    <td>
	                            <input ref="knoxName" type="text" class="text_input w100" v-model="knoxName" :disabled="true"/>
	                    </td>
	                </tr>
                    <tr>
	                	<th>Email </th>
	                    <td>
	                            <input ref="Email" type="text" class="text_input w100"  v-model="Email" :disabled="true" />
	                    </td>
	                    <th>KnoxId </th>
	                    <td> 
	                            <input ref="knoxId" type="text" class="text_input w100" v-model="knoxId" :disabled="true"/>
	                    </td>
		            </tr> 
            </tbody>
        </table>
        <!-- go list button -->
        <div class="btn_wrap topLine">
            <a href="JavaScript:"
               @click="goList()" class="btn_white size_full" title>{{$t('BUTTON.GLOBAL.LIST')}}</a>
            <div class="btn_right">
                <a href="JavaScript:" class="btn_white" @click="cateDelete()">{{$t('BUTTON.GLOBAL.DELETE')}}</a>
                <a v-if="!viewMode" class="btn_blue" @click="cateSave('S')">{{$t('BUTTON.GLOBAL.SAVE')}}</a>
                <a v-if="viewMode" class="btn_blue" @click="cateSave('U')">{{$t('BUTTON.GLOBAL.UPDATE')}}</a>
            </div>
        </div>
       
        <!-- go list button -->
<!--         <div v-if="viewMode" class="btn_wrap_full topLine mt25"> -->
<!--             <a href="JavaScript:" @click="goList()" class="btn_white size_full" title >{{$t('BUTTON.GLOBAL.LIST')}}</a> -->
<!--         </div> -->
    </div>
    <!-- contents -->
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';
import _ from 'lodash';
import $ from 'jquery';
import constants from '@/constants';
import SDLLocale from '@/mixin/SDLLocale';
import { SDLUtil, MenuUtil } from '@/utils';
import { EventBus } from '@/utils/EventBus';
import api  from '@/service';
// import UpperCodePopup from './UpperCodePopup';

import DuplicationApprovalPopup from '~c/popup/DuplicationApprovalPopup';
let reg_email = /([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;

export default {
    name: 'approvalManageDetail',
    props: {
        params: {},
        pCategoryId: '',
        distinction: '',
    },
    data() {
        return {
            isLoading: true,
            viewMode: false, // 'false=create, true=modify'
            categoryId: '',
            
            categoryName: '',
            categoryType: '',
            queryId: '',
            cacheStatus: '',
            status: 'A',
            upperCode: '',
            localeCd: '',
            localeList: [],
            //--------------------------
            distinctionType:'SB',
            categoryStatus:'',
            categoryStatusMX:'D',
            guideType:'',
            guideTypeMX:'ALL',
            roleStatus:'',
            categoryComboList: [],     // Category 1 List
            emailAddresses: '',
            knoxId: '',
            knoxName: '',
            id_key_val:'SAVE',
            userId:'',
            fullName:'',
            Email:'',
            SORTORD:'',
        };
    },
    computed: {},
    watch: {},
    components: {},
    methods: {
        initLoad() {
            if (this.pCategoryId) {
                this.setCategory();
                this.dataLoad();
            } else {
                this.setCategory();
                this.localeList = [];
            }
        },
        
    	// Filter non-numeric characters
        handleNumberInput(e) {
            this.SORTORD = e.target.value
              .replace( /[^1-9]/g, '') // Filter non-numeric characters
              .slice(0, 10) // Limited length
        },
        
        dataLoad() {
            const data = { ID_KEY: this.pCategoryId.ID_KEY[0] , distinction : this.pCategoryId.distinction };
            if(this.pCategoryId.ID_KEY[0] !== null){this.id_key_val = this.pCategoryId.ID_KEY[0];} 
            return axios
                .get(`${SDLUtil.API_URL}/basis/admin/knowledgeManager/approval/approvalDetail.skp`, { params: data })
                .then(resp => {
                    let cate = resp.data.rows;
                    this.viewMode = this.pCategoryId ? true : false;
                    this.distinctionType = cate[0].DISTINCTION || '';
                    this.categoryStatus = cate[0].CATEGORY;
                    this.guideType = cate[0].GUIDETYPE;
                    this.roleStatus = cate[0].ROLE;
                    this.emailAddresses = cate[0].NAME;
                    this.Email = cate[0].EMAIL;
                    this.knoxName = cate[0].NAME;
                    this.knoxId = cate[0].USERID;
                    this.SORTORD = cate[0].SORTORD;
                })
                .catch(err => {
                    console.error(err);//console.error(error);//cb 22.8 error undefined
                });
        },
        
     	// Code combo list api
        async getCodeComboList(categoryVal, categoryCode) {
            const  codeResp = await api.getComboList(categoryVal, categoryCode, this.getUserCorpCd);
            return codeResp;
        },
     
        // 첫번째 카테고리 설정
        setCategory() {
            this.getCodeComboList("0", "ADM_CATEGORY_A").then(data => {
                this.categoryComboList = data;
            });

            let that = this;
            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        
        saveParams(exclude = []) {
        	let params ;
        	if(this.distinctionType == 'SB'){
        		 params = {
                        distinction: this.distinctionType,
                        categoryStatus: this.categoryStatus,
                        guideType: this.guideType,
                        roleStatus: this.roleStatus,
                        emailAddresses: this.Email,
                        name : this.knoxName,
                        knoxId :this.knoxId,
                        ID_KEY : this.id_key_val,
                        SORTORD : this.SORTORD,
                    };
        	}else{
        		 params = {
                        distinction: this.distinctionType,
                        categoryStatus: "D",
                        guideType: "ALL",
                        roleStatus: this.roleStatus,
                        emailAddresses: this.Email,
                        name : this.knoxName,
                        knoxId :this.knoxId,
                        ID_KEY : this.id_key_val,
                        SORTORD : this.SORTORD,
                    };
        	}
            
            return params;
        },
        // aftMode: 1=goList(delete), 2=refresh(save)
        saveExec(url, formData, msg, aftMode) {
            SDLUtil.showLoadingBar(true);
            return axios
                .post(url, qs.stringify(formData), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                .then(resp => {
                    SDLUtil.showLoadingBar(false);
                    if (resp.data.result > 0) {
                        Vue.toasted.show(
                            SDLUtil.getMsgProp(msg), {
                                theme: "toasted-primary",
                                position: "top-center",
                                duration : 3000
                            }
                        );
                        if (aftMode == 0) { // Save
                            this.viewMode = true;
                        } else if (aftMode == 1) { // Delete
                            EventBus.$emit('goCodeList', 1);
                        } else if (aftMode == 2) {
                            this.refresh(null);
                        }
                    } else {
                        SDLUtil.alert('Error occured ' + resp.status);
                    }
                })
                .catch(err => {
                    SDLUtil.alert('Error occured : ' + err);
                    this.searchStatus = 'error';
                    this.gridData = [];
                    SDLUtil.showLoadingBar(false);
                });
        },
        categoryValidateion() {
            let bRes = true;
            let valids = [this.categoryId, this.categoryName, this.categoryType, this.cacheStatus, this.status];
            let titles = ['Distinction', 'Product Category', 'Guide Type', 'Role', 'User Id'];
            if (this.categoryType == 'D') {
                valids.push(this.queryId);
                titles.push('Query ID');
            }
            $.each(valids, function(idx, elm) {
                if (!elm) {
                    bRes = false;
                    SDLUtil.alert('Empty value of [' + titles[idx] + ']');
                    return;
                }
            });
            return bRes;
        },
        // Main Save
        cateSave(flag) {
        	
        	if(this.distinctionType==""){
        		alert("Please select distinction Type.");
        		return;
        	}
        	if(this.distinctionType == 'SB'){
        		if(this.categoryStatus==""){
            		alert("Please select category Type.");
            		return;
            	}
            	if(this.guideType==""){
            		alert("Please select guide Type.");
            		return;
            	}
        	}
        	if(this.roleStatus==""){
        		alert("Please select role Type.");
        		return;
        	}
        	if(this.SORTORD==""){
        		alert("Please set the approval order.");
        		return;
        	}
        	if (!(/[@]/.test(this.Email))) {
        		alert("Please add user!");
        		return ;
        	}
            const fData = this.saveParams();
            SDLUtil.confirm({
                msg: 'MESSAGE.HME.SUBMIT.CONFIRM',
                title: 'BUTTON.GLOBAL.SAVE',
                onOkEvt: () => {
                    let url = `${SDLUtil.API_URL}/basis/admin/knowledgeManager/approval/approvalSave.skp`;
                    this.saveExec(url, fData, 'MESSAGE.SUCCESS.SAVED', 1);
                    this.goList();
                },
            });
        },
        
        
        
        // Main Delete
        cateDelete() {
            //const fdata = { ID_KEY: this.pCategoryId[0] , distinction : this.pCategoryId[1] };
            const fdata = { slectList: this.pCategoryId.ID_KEY , distinction : this.pCategoryId.distinction };
            SDLUtil.confirm({
                msg: 'MESSAGE.DATA.REMOVE.CONFIRM',
                title: 'BUTTON.GLOBAL.DELETE',
                onOkEvt: () => {
                    let url = `${SDLUtil.API_URL}/basis/admin/knowledgeManager/approval/approvalDelete.skp`;
                    this.saveExec(url, fdata , 'MESSAGE.SUCCESS.DELETED', 1);
                    this.goList();
                },
            });
        },
        
        //  user ID
        async emailAddressFind(v) {
        	let email = v;
        	if (SDLUtil.isNull(await this.emailAddressCheck(email))) {
        		// Cannot find user name or e-Mail address on KNOX. <br/>Please check and try again.
        		SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.KNOX.EMAIL.NOFOUND'));
        	}
        },
        
        async emailAddressCheck(v) {
            let searchFullName = '';
            let searchEmailAddresses = '';

            if (reg_email.test(v)) {
                searchEmailAddresses = v;
            } else {
                searchFullName = v;
            }
            SDLUtil.showLoadingBar(true);
            try{
                const resp = await axios.post(`${SDLUtil.API_URL}/basis/approval/handleSelect.skp`,
                    qs.stringify({fullName: searchFullName,emailAddresses: searchEmailAddresses,}))
                let result = JSON.parse(resp.data.result);

                if (!SDLUtil.isNull(result.employees) && 0 < result.employees.length) {
                	console.log(result.employees);
                	if (1 === result.employees.length) { 
		               	for (const iterator of result.employees) {
		               		 //this.emailAddressesReal = iterator.emailAddress;
		                     this.knoxId = iterator.userId;
		                     this.knoxName = iterator.fullName;
		               		 this.Email = iterator.emailAddress;
		               	 }	
                	} else {
                         // 동명 이인 팝업 실행
                         SDLUtil.showLoadingBar(false);
                         this.duplicationApprovalPopup(result.employees);
                    }
                }	
                SDLUtil.showLoadingBar(false);
                return result.employees;   
            } catch (err){
                Vue.$log.error(err);
                SDLUtil.errorAlert(err);
                SDLUtil.showLoadingBar(false);
            }
        },
        
        duplicationApprovalPopup(propsPath, aplnRole, searchName) {
            SDLUtil.show(
                DuplicationApprovalPopup,
                {
                    propsPath: propsPath,
                    rtnFunc: v => {
		               		 //this.emailAddressesReal = v.emailAddress;
		                     this.knoxId = v.userId;
		                     this.knoxName = v.fullName;
		               		 this.Email = v.emailAddress;
                    },
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        
        refresh(data) {
            // 데이터 다시 불러오기
            if (this.categoryId) {
                this.pCategoryId = this.categoryId;
                this.dataLoad();
            }
        },
        goList() {
            EventBus.$emit('goCodeList');
            this.$router.push({ name: 'ApprovalManageList' });
        },
    }, // methods
    created() {
        EventBus.$on('refresh', this.refresh);
    },
    mounted() {
        this.initLoad();
        //if (!this.viewMode) this.$refs.categoryId.focus();
    },
    beforeDestroy() {
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('refresh');
    },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/knowledgeManager/approval/ApprovalManageView.vue